"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import useSearchCourses from "@/hook/useSearchCourses";

export default function SearchBarDesktop() {
  const {
    searchText,
    setSearchText,
    suggestions,
    setSuggestions,
    showDropdown,
    setShowDropdown,
    wrapperRef,
    handleInputChange,
  } = useSearchCourses();

  return (
    <div className="relative mx-auto xl:mx-0 hidden md:block" ref={wrapperRef}>
      <form className="search-box" onSubmit={(e) => e.preventDefault()}>
        <input
          type="text"
          placeholder="কোর্স সার্চ করো"
          className="search-input hidden md:inline-block"
          value={searchText}
          onChange={handleInputChange}
        />
        <button type="submit" className="search-button">
          <Image
            src="/images/header-footer/search.avif"
            alt="Search Icon"
            width={20}
            height={20}
            className="search-icon"
            priority
          />
        </button>
      </form>

      {showDropdown && suggestions.length > 0 && (
        <div className="absolute z-50 w-full bg-white border border-gray-200 mt-2 rounded shadow">
          {suggestions.map((course, index) => (
            <Link
              href={`/course/${course.slug}`}
              key={index}
              className="flex items-center p-2 hover:bg-gray-100 hover:[.dark_&]:bg-d-oxford-blue"
              onClick={() => {
                setSearchText("");
                setSuggestions([]);
                setShowDropdown(false);
              }}
            >
              {course.thumbnail_url && (
                <Image
                  src={course.thumbnail_url}
                  alt={course.title}
                  width={40}
                  height={40}
                  className="rounded object-cover mr-2"
                />
              )}
              <span className="text-sm [.dark_&]:text-d-white">{course.title}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
